<template>
  <div class="file" :class="{'file_wrongFileType': wrongFileType}">
    <div class="file__icon">
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.0723 4.28516C11.0723 2.90444 12.1916 1.78516 13.5723 1.78516H28.3252L38.2151 12.4358V35.7137C38.2151 37.0944 37.0958 38.2137 35.7151 38.2137H13.5723C12.1916 38.2137 11.0723 37.0944 11.0723 35.7137V28.5709C11.0723 27.9791 11.552 27.4994 12.1437 27.4994C12.7354 27.4994 13.2151 27.9791 13.2151 28.5709V35.7137C13.2151 35.911 13.375 36.0709 13.5723 36.0709H35.7151C35.9124 36.0709 36.0723 35.911 36.0723 35.7137V13.928H26.7866V3.92801H13.5723C13.375 3.92801 13.2151 4.08791 13.2151 4.28516V14.9994C13.2151 15.5912 12.7354 16.0709 12.1437 16.0709C11.552 16.0709 11.0723 15.5912 11.0723 14.9994V4.28516ZM28.9294 5.58502L34.6867 11.7852H28.9294V5.58502Z" fill="#343540"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.78516 18.5711C1.78516 16.4015 3.54404 14.6426 5.71373 14.6426H21.428C23.5977 14.6426 25.3566 16.4015 25.3566 18.5711V24.9997C25.3566 27.1694 23.5977 28.9283 21.428 28.9283H5.71373C3.54404 28.9283 1.78516 27.1694 1.78516 24.9997V18.5711ZM5.71373 16.7854C4.7275 16.7854 3.92801 17.5849 3.92801 18.5711V24.9997C3.92801 25.9859 4.7275 26.7854 5.71373 26.7854H21.428C22.4142 26.7854 23.2137 25.9859 23.2137 24.9997V18.5711C23.2137 17.5849 22.4142 16.7854 21.428 16.7854H5.71373Z" fill="#F22557"/>
      </svg>
      <div class="file__icon-ext">{{ ext }}</div>
    </div>
    <div class="file__info">
      <div class="file__info-name">{{ name }}</div>
      <div class="file__info-size">{{ size }}</div>
    </div>
    <div class="file__actions" v-if="actions">
      <button @click="$emit('delete')">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 9V17M14 9V17M5 7H19M10 5H14M7 7H17V19H7V7Z" stroke="#9496A1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <button @click="$emit('edit')">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 12.125V18C19 19.1046 18.1046 20 17 20H7C5.89543 20 5 19.1046 5 18V8C5 6.89543 5.89543 6 7 6H13" stroke="#9496A1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M17 6L11.5 11.5L11 14L13.5 13.5L19 8.00002M17 6L18 5.00001C18.5523 4.44772 19.4477 4.44772 20 5.00001V5.00001C20.5523 5.5523 20.5523 6.44773 20 7.00002L19 8.00002M17 6L19 8.00002" stroke="#9496A1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      percentage: {type: Number, default: 0},
      name: {type: String, default: 'No name'},
      size: {type: String, default: '123.4 KB'},
      ext: {type: String, default: 'png'},
      actions: {type: Boolean, default: true},
      wrongFileType: {type: Boolean, default: false}
    }
  }
</script>

<style lang="sass">
.file
  display: flex
  &:not(:last-child)
    margin-bottom: 8px
  &__icon
    align-self: flex-start
    flex-shrink: 0
    position: relative
    margin-right: 24px
    svg
      width: 40px
      height: 40px
    &-ext
      position: absolute
      bottom: 14px
      font-weight: 700
      font-size: 7px
      color: #F22557
      text-align: center
      width: 20px
      left: 4px
      line-height: 1
  &__info
    align-self: flex-start
    flex-grow: 1
    margin-right: 16px
    overflow: hidden
    padding-top: 3px
    &-name 
      font-size: 16px
      line-height: 1.28
      margin-bottom: 7px
      color: colors.$gray3
    &-size
      font-size: 12px
      line-height: 1.14
      color: colors.$newgray
  &__actions
    display: flex
    align-items: center
    button:not(:last-child)
      margin-right: 16px
    svg
      width: 24px
      height: 24px
  &_wrongFileType &__info-name::after
    color: colors.$newred
    content: ' (Неверный тип файла!)'
    font-weight: 700
    font-size: 13px
  @include for-mob
    &__icon, &__info, &__actions button:not(:last-child)
      margin-right: 12px
</style>